import { isMerchandiseShippingItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'

const getMerchandiseShippingItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.MerchandiseShippingItem> => {
    return items.filter(isMerchandiseShippingItem)
  },
)

export default getMerchandiseShippingItems
